import React, { createContext, useContext, useEffect, useMemo } from 'react';
import { useOktaAuth } from '@okta/okta-react';

const AuthContext = createContext(null);

export const ROLES = {
    ADMIN: 'admin',
    OPERATIONS: 'operations',
    PARTNER: 'partner',
  };

export const AuthProvider = ({ children }) => {
  const { authState, oktaAuth } = useOktaAuth();

  const handleLogout = async () => {
    try {
      await oktaAuth.signOut({
        revokeAccessToken: true,
        revokeRefreshToken: false
    });
    } catch (err) {
      console.error('Error during signOut:', err);
    }
  };

  // Role enum
  

  const mapGroupsToRole = (groups = []) => {
    const lowered = groups.map(g => String(g).toLowerCase());
    if (lowered.some(g => g.includes('partner') || g.includes('-partner'))) return ROLES.PARTNER;
    if (lowered.some(g => g.includes('ops') || g.includes('-ops') || g.includes('operations'))) return ROLES.OPERATIONS;
    if (lowered.some(g => g.includes('admin'))) return ROLES.ADMIN;
    return null;
  };

  const value = useMemo(() => {
    const user = authState?.idToken?.claims;
    const groups = user?.groups || [];
    const role = mapGroupsToRole(groups);

    return {
      isAuthenticated: authState?.isAuthenticated,
      user,
      groups,
      role,
      hasRole: (r) => {
        if (Object.values(ROLES).includes(r)) return r === role;
        return groups.includes(r);
      },
      handleLogout,
    };
  }, [authState, oktaAuth]);

  // ADD THIS BLOCK:
  useEffect(() => {
    if (value.isAuthenticated) {
      console.log('--- Auth Debugger ---');
      console.log('User Role:', value.role);     // Shows 'partner', 'operations', etc.
      console.log('Raw Groups:', value.groups); // Verify the groups coming from Okta
      console.log('User Claims:', value.user);   // Full profile info
      console.log('---------------------');
    }
  }, [value]);

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
